// source: assetsMsg.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.AssetsPbMsg', null, global);
goog.exportSymbol('proto.AssetsPbMsg.CurrencyAssets', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.AssetsPbMsg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.AssetsPbMsg.repeatedFields_, null);
};
goog.inherits(proto.AssetsPbMsg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.AssetsPbMsg.displayName = 'proto.AssetsPbMsg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.AssetsPbMsg.CurrencyAssets = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.AssetsPbMsg.CurrencyAssets, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.AssetsPbMsg.CurrencyAssets.displayName = 'proto.AssetsPbMsg.CurrencyAssets';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.AssetsPbMsg.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.AssetsPbMsg.prototype.toObject = function(opt_includeInstance) {
  return proto.AssetsPbMsg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.AssetsPbMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AssetsPbMsg.toObject = function(includeInstance, msg) {
  var f, obj = {
    totalcnyaccountrights: jspb.Message.getFieldWithDefault(msg, 1, ""),
    totalbtcunrealizedsurplus: jspb.Message.getFieldWithDefault(msg, 2, ""),
    totalbtcaccountrights: jspb.Message.getFieldWithDefault(msg, 3, ""),
    totalbtcavaliablemargins: jspb.Message.getFieldWithDefault(msg, 4, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.AssetsPbMsg.CurrencyAssets.toObject, includeInstance),
    brokerid: jspb.Message.getFieldWithDefault(msg, 7, 0),
    sort: jspb.Message.getFieldWithDefault(msg, 8, 0),
    status: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.AssetsPbMsg}
 */
proto.AssetsPbMsg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.AssetsPbMsg;
  return proto.AssetsPbMsg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.AssetsPbMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.AssetsPbMsg}
 */
proto.AssetsPbMsg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalcnyaccountrights(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalbtcunrealizedsurplus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalbtcaccountrights(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalbtcavaliablemargins(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    case 6:
      var value = new proto.AssetsPbMsg.CurrencyAssets;
      reader.readMessage(value,proto.AssetsPbMsg.CurrencyAssets.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBrokerid(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSort(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.AssetsPbMsg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.AssetsPbMsg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.AssetsPbMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AssetsPbMsg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalcnyaccountrights();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTotalbtcunrealizedsurplus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalbtcaccountrights();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTotalbtcavaliablemargins();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.AssetsPbMsg.CurrencyAssets.serializeBinaryToWriter
    );
  }
  f = message.getBrokerid();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getSort();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.toObject = function(opt_includeInstance) {
  return proto.AssetsPbMsg.CurrencyAssets.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.AssetsPbMsg.CurrencyAssets} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AssetsPbMsg.CurrencyAssets.toObject = function(includeInstance, msg) {
  var f, obj = {
    cnprice: jspb.Message.getFieldWithDefault(msg, 1, ""),
    applogo: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fee: jspb.Message.getFieldWithDefault(msg, 3, ""),
    orderfee: jspb.Message.getFieldWithDefault(msg, 4, ""),
    realavailablebalance: jspb.Message.getFieldWithDefault(msg, 5, ""),
    realizedsurplus: jspb.Message.getFieldWithDefault(msg, 6, ""),
    type: jspb.Message.getFieldWithDefault(msg, 7, 0),
    availablebalance: jspb.Message.getFieldWithDefault(msg, 8, ""),
    positionaccountrights: jspb.Message.getFieldWithDefault(msg, 9, ""),
    maintenancemargin: jspb.Message.getFieldWithDefault(msg, 10, ""),
    price: jspb.Message.getFieldWithDefault(msg, 12, ""),
    realpositionaccountrights: jspb.Message.getFieldWithDefault(msg, 13, ""),
    unrealizedsurplusbtcvalue: jspb.Message.getFieldWithDefault(msg, 14, ""),
    unrealizedsurplusvalue: jspb.Message.getFieldWithDefault(msg, 15, ""),
    accountrightsvalue: jspb.Message.getFieldWithDefault(msg, 16, ""),
    openmargin: jspb.Message.getFieldWithDefault(msg, 17, ""),
    frozenbalance: jspb.Message.getFieldWithDefault(msg, 18, ""),
    sort: jspb.Message.getFieldWithDefault(msg, 19, 0),
    env: jspb.Message.getFieldWithDefault(msg, 20, 0),
    accountrightsbtcvalue: jspb.Message.getFieldWithDefault(msg, 21, ""),
    accountrightscnvalue: jspb.Message.getFieldWithDefault(msg, 22, ""),
    decimalplaces: jspb.Message.getFieldWithDefault(msg, 23, 0),
    currentordermargin: jspb.Message.getFieldWithDefault(msg, 24, ""),
    weblogo: jspb.Message.getFieldWithDefault(msg, 25, ""),
    unrealizedsurplus: jspb.Message.getFieldWithDefault(msg, 26, ""),
    ordermargin: jspb.Message.getFieldWithDefault(msg, 27, ""),
    positionmargin: jspb.Message.getFieldWithDefault(msg, 28, ""),
    contractcode: jspb.Message.getFieldWithDefault(msg, 29, ""),
    currencycode: jspb.Message.getFieldWithDefault(msg, 30, ""),
    availablemargin: jspb.Message.getFieldWithDefault(msg, 31, ""),
    btcvalue: jspb.Message.getFieldWithDefault(msg, 32, ""),
    currencycodedisplayname: jspb.Message.getFieldWithDefault(msg, 33, ""),
    followunrealizedsurplus: jspb.Message.getFieldWithDefault(msg, 34, ""),
    followrealizedsurplus: jspb.Message.getFieldWithDefault(msg, 35, ""),
    biztype: jspb.Message.getFieldWithDefault(msg, 36, ""),
    donationopenmargin: jspb.Message.getFieldWithDefault(msg, 37, ""),
    donationmaintenancemargin: jspb.Message.getFieldWithDefault(msg, 38, ""),
    donationfee: jspb.Message.getFieldWithDefault(msg, 39, ""),
    donationordermargin: jspb.Message.getFieldWithDefault(msg, 40, ""),
    donationorderfee: jspb.Message.getFieldWithDefault(msg, 41, ""),
    donationaccountrights: jspb.Message.getFieldWithDefault(msg, 42, ""),
    donationvalue: jspb.Message.getFieldWithDefault(msg, 43, ""),
    realavailabledonation: jspb.Message.getFieldWithDefault(msg, 44, ""),
    availabledonation: jspb.Message.getFieldWithDefault(msg, 45, ""),
    donationfrozen: jspb.Message.getFieldWithDefault(msg, 46, ""),
    donationpositionmargin: jspb.Message.getFieldWithDefault(msg, 47, ""),
    skill: jspb.Message.getFieldWithDefault(msg, 48, 0),
    totalshadowmargin: jspb.Message.getFieldWithDefault(msg, 49, ""),
    totalopencardvalue: jspb.Message.getFieldWithDefault(msg, 50, ""),
    opencardid: jspb.Message.getFieldWithDefault(msg, 51, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.AssetsPbMsg.CurrencyAssets}
 */
proto.AssetsPbMsg.CurrencyAssets.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.AssetsPbMsg.CurrencyAssets;
  return proto.AssetsPbMsg.CurrencyAssets.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.AssetsPbMsg.CurrencyAssets} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.AssetsPbMsg.CurrencyAssets}
 */
proto.AssetsPbMsg.CurrencyAssets.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCnprice(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplogo(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFee(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderfee(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRealavailablebalance(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRealizedsurplus(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setType(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvailablebalance(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPositionaccountrights(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setMaintenancemargin(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrice(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setRealpositionaccountrights(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnrealizedsurplusbtcvalue(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnrealizedsurplusvalue(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountrightsvalue(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpenmargin(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrozenbalance(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSort(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEnv(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountrightsbtcvalue(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountrightscnvalue(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDecimalplaces(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentordermargin(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setWeblogo(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnrealizedsurplus(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrdermargin(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setPositionmargin(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setContractcode(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencycode(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvailablemargin(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setBtcvalue(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencycodedisplayname(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setFollowunrealizedsurplus(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setFollowrealizedsurplus(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setBiztype(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setDonationopenmargin(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setDonationmaintenancemargin(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setDonationfee(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setDonationordermargin(value);
      break;
    case 41:
      var value = /** @type {string} */ (reader.readString());
      msg.setDonationorderfee(value);
      break;
    case 42:
      var value = /** @type {string} */ (reader.readString());
      msg.setDonationaccountrights(value);
      break;
    case 43:
      var value = /** @type {string} */ (reader.readString());
      msg.setDonationvalue(value);
      break;
    case 44:
      var value = /** @type {string} */ (reader.readString());
      msg.setRealavailabledonation(value);
      break;
    case 45:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvailabledonation(value);
      break;
    case 46:
      var value = /** @type {string} */ (reader.readString());
      msg.setDonationfrozen(value);
      break;
    case 47:
      var value = /** @type {string} */ (reader.readString());
      msg.setDonationpositionmargin(value);
      break;
    case 48:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSkill(value);
      break;
    case 49:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalshadowmargin(value);
      break;
    case 50:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalopencardvalue(value);
      break;
    case 51:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpencardid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.AssetsPbMsg.CurrencyAssets.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.AssetsPbMsg.CurrencyAssets} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AssetsPbMsg.CurrencyAssets.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCnprice();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getApplogo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFee();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOrderfee();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRealavailablebalance();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRealizedsurplus();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getType();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getAvailablebalance();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPositionaccountrights();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getMaintenancemargin();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPrice();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getRealpositionaccountrights();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getUnrealizedsurplusbtcvalue();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getUnrealizedsurplusvalue();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getAccountrightsvalue();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getOpenmargin();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getFrozenbalance();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getSort();
  if (f !== 0) {
    writer.writeInt32(
      19,
      f
    );
  }
  f = message.getEnv();
  if (f !== 0) {
    writer.writeInt32(
      20,
      f
    );
  }
  f = message.getAccountrightsbtcvalue();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getAccountrightscnvalue();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getDecimalplaces();
  if (f !== 0) {
    writer.writeInt32(
      23,
      f
    );
  }
  f = message.getCurrentordermargin();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getWeblogo();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getUnrealizedsurplus();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getOrdermargin();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getPositionmargin();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getContractcode();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getCurrencycode();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getAvailablemargin();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getBtcvalue();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getCurrencycodedisplayname();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getFollowunrealizedsurplus();
  if (f.length > 0) {
    writer.writeString(
      34,
      f
    );
  }
  f = message.getFollowrealizedsurplus();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getBiztype();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getDonationopenmargin();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = message.getDonationmaintenancemargin();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getDonationfee();
  if (f.length > 0) {
    writer.writeString(
      39,
      f
    );
  }
  f = message.getDonationordermargin();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getDonationorderfee();
  if (f.length > 0) {
    writer.writeString(
      41,
      f
    );
  }
  f = message.getDonationaccountrights();
  if (f.length > 0) {
    writer.writeString(
      42,
      f
    );
  }
  f = message.getDonationvalue();
  if (f.length > 0) {
    writer.writeString(
      43,
      f
    );
  }
  f = message.getRealavailabledonation();
  if (f.length > 0) {
    writer.writeString(
      44,
      f
    );
  }
  f = message.getAvailabledonation();
  if (f.length > 0) {
    writer.writeString(
      45,
      f
    );
  }
  f = message.getDonationfrozen();
  if (f.length > 0) {
    writer.writeString(
      46,
      f
    );
  }
  f = message.getDonationpositionmargin();
  if (f.length > 0) {
    writer.writeString(
      47,
      f
    );
  }
  f = message.getSkill();
  if (f !== 0) {
    writer.writeInt32(
      48,
      f
    );
  }
  f = message.getTotalshadowmargin();
  if (f.length > 0) {
    writer.writeString(
      49,
      f
    );
  }
  f = message.getTotalopencardvalue();
  if (f.length > 0) {
    writer.writeString(
      50,
      f
    );
  }
  f = message.getOpencardid();
  if (f !== 0) {
    writer.writeInt64(
      51,
      f
    );
  }
};


/**
 * optional string cnPrice = 1;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getCnprice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setCnprice = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string appLogo = 2;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getApplogo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setApplogo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string fee = 3;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getFee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setFee = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string orderFee = 4;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getOrderfee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setOrderfee = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string realAvailableBalance = 5;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getRealavailablebalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setRealavailablebalance = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string realizedSurplus = 6;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getRealizedsurplus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setRealizedsurplus = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 type = 7;
 * @return {number}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setType = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string availableBalance = 8;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getAvailablebalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setAvailablebalance = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string positionAccountRights = 9;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getPositionaccountrights = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setPositionaccountrights = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string maintenanceMargin = 10;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getMaintenancemargin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setMaintenancemargin = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string price = 12;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string realPositionAccountRights = 13;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getRealpositionaccountrights = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setRealpositionaccountrights = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string unRealizedSurplusBtcValue = 14;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getUnrealizedsurplusbtcvalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setUnrealizedsurplusbtcvalue = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string unRealizedSurplusValue = 15;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getUnrealizedsurplusvalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setUnrealizedsurplusvalue = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string accountRightsValue = 16;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getAccountrightsvalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setAccountrightsvalue = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string openMargin = 17;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getOpenmargin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setOpenmargin = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string frozenBalance = 18;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getFrozenbalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setFrozenbalance = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional int32 sort = 19;
 * @return {number}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getSort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setSort = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int32 env = 20;
 * @return {number}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getEnv = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setEnv = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional string accountRightsBtcValue = 21;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getAccountrightsbtcvalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setAccountrightsbtcvalue = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string accountRightsCnValue = 22;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getAccountrightscnvalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setAccountrightscnvalue = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional int32 decimalPlaces = 23;
 * @return {number}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getDecimalplaces = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setDecimalplaces = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional string currentOrderMargin = 24;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getCurrentordermargin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setCurrentordermargin = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string webLogo = 25;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getWeblogo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setWeblogo = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string unRealizedSurplus = 26;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getUnrealizedsurplus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setUnrealizedsurplus = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string orderMargin = 27;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getOrdermargin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setOrdermargin = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string positionMargin = 28;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getPositionmargin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setPositionmargin = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string contractCode = 29;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getContractcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setContractcode = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string currencyCode = 30;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getCurrencycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setCurrencycode = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string availableMargin = 31;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getAvailablemargin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setAvailablemargin = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional string btcValue = 32;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getBtcvalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setBtcvalue = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional string currencyCodeDisplayName = 33;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getCurrencycodedisplayname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setCurrencycodedisplayname = function(value) {
  return jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * optional string followUnRealizedSurplus = 34;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getFollowunrealizedsurplus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setFollowunrealizedsurplus = function(value) {
  return jspb.Message.setProto3StringField(this, 34, value);
};


/**
 * optional string followRealizedSurplus = 35;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getFollowrealizedsurplus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setFollowrealizedsurplus = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional string bizType = 36;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getBiztype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setBiztype = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional string donationOpenMargin = 37;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getDonationopenmargin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setDonationopenmargin = function(value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional string donationMaintenanceMargin = 38;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getDonationmaintenancemargin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setDonationmaintenancemargin = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional string donationFee = 39;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getDonationfee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setDonationfee = function(value) {
  return jspb.Message.setProto3StringField(this, 39, value);
};


/**
 * optional string donationOrderMargin = 40;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getDonationordermargin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setDonationordermargin = function(value) {
  return jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional string donationOrderFee = 41;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getDonationorderfee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 41, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setDonationorderfee = function(value) {
  return jspb.Message.setProto3StringField(this, 41, value);
};


/**
 * optional string donationAccountRights = 42;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getDonationaccountrights = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 42, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setDonationaccountrights = function(value) {
  return jspb.Message.setProto3StringField(this, 42, value);
};


/**
 * optional string donationValue = 43;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getDonationvalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 43, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setDonationvalue = function(value) {
  return jspb.Message.setProto3StringField(this, 43, value);
};


/**
 * optional string realAvailableDonation = 44;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getRealavailabledonation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 44, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setRealavailabledonation = function(value) {
  return jspb.Message.setProto3StringField(this, 44, value);
};


/**
 * optional string availableDonation = 45;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getAvailabledonation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 45, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setAvailabledonation = function(value) {
  return jspb.Message.setProto3StringField(this, 45, value);
};


/**
 * optional string donationFrozen = 46;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getDonationfrozen = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 46, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setDonationfrozen = function(value) {
  return jspb.Message.setProto3StringField(this, 46, value);
};


/**
 * optional string donationPositionMargin = 47;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getDonationpositionmargin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 47, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setDonationpositionmargin = function(value) {
  return jspb.Message.setProto3StringField(this, 47, value);
};


/**
 * optional int32 skill = 48;
 * @return {number}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getSkill = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 48, 0));
};


/**
 * @param {number} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setSkill = function(value) {
  return jspb.Message.setProto3IntField(this, 48, value);
};


/**
 * optional string totalShadowMargin = 49;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getTotalshadowmargin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 49, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setTotalshadowmargin = function(value) {
  return jspb.Message.setProto3StringField(this, 49, value);
};


/**
 * optional string totalOpenCardValue = 50;
 * @return {string}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getTotalopencardvalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 50, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setTotalopencardvalue = function(value) {
  return jspb.Message.setProto3StringField(this, 50, value);
};


/**
 * optional int64 openCardId = 51;
 * @return {number}
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.getOpencardid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 51, 0));
};


/**
 * @param {number} value
 * @return {!proto.AssetsPbMsg.CurrencyAssets} returns this
 */
proto.AssetsPbMsg.CurrencyAssets.prototype.setOpencardid = function(value) {
  return jspb.Message.setProto3IntField(this, 51, value);
};


/**
 * optional string totalCnyAccountRights = 1;
 * @return {string}
 */
proto.AssetsPbMsg.prototype.getTotalcnyaccountrights = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg} returns this
 */
proto.AssetsPbMsg.prototype.setTotalcnyaccountrights = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string totalBtcUnRealizedSurplus = 2;
 * @return {string}
 */
proto.AssetsPbMsg.prototype.getTotalbtcunrealizedsurplus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg} returns this
 */
proto.AssetsPbMsg.prototype.setTotalbtcunrealizedsurplus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string totalBtcAccountRights = 3;
 * @return {string}
 */
proto.AssetsPbMsg.prototype.getTotalbtcaccountrights = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg} returns this
 */
proto.AssetsPbMsg.prototype.setTotalbtcaccountrights = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string totalBtcAvaliableMargins = 4;
 * @return {string}
 */
proto.AssetsPbMsg.prototype.getTotalbtcavaliablemargins = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.AssetsPbMsg} returns this
 */
proto.AssetsPbMsg.prototype.setTotalbtcavaliablemargins = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 userId = 5;
 * @return {number}
 */
proto.AssetsPbMsg.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.AssetsPbMsg} returns this
 */
proto.AssetsPbMsg.prototype.setUserid = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * repeated CurrencyAssets data = 6;
 * @return {!Array<!proto.AssetsPbMsg.CurrencyAssets>}
 */
proto.AssetsPbMsg.prototype.getDataList = function() {
  return /** @type{!Array<!proto.AssetsPbMsg.CurrencyAssets>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.AssetsPbMsg.CurrencyAssets, 6));
};


/**
 * @param {!Array<!proto.AssetsPbMsg.CurrencyAssets>} value
 * @return {!proto.AssetsPbMsg} returns this
*/
proto.AssetsPbMsg.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.AssetsPbMsg.CurrencyAssets=} opt_value
 * @param {number=} opt_index
 * @return {!proto.AssetsPbMsg.CurrencyAssets}
 */
proto.AssetsPbMsg.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.AssetsPbMsg.CurrencyAssets, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.AssetsPbMsg} returns this
 */
proto.AssetsPbMsg.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional int32 brokerId = 7;
 * @return {number}
 */
proto.AssetsPbMsg.prototype.getBrokerid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.AssetsPbMsg} returns this
 */
proto.AssetsPbMsg.prototype.setBrokerid = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 sort = 8;
 * @return {number}
 */
proto.AssetsPbMsg.prototype.getSort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.AssetsPbMsg} returns this
 */
proto.AssetsPbMsg.prototype.setSort = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 status = 9;
 * @return {number}
 */
proto.AssetsPbMsg.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.AssetsPbMsg} returns this
 */
proto.AssetsPbMsg.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


goog.object.extend(exports, proto);
